var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftExcelLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MicrosoftExcelLogo",
    clipPath: "url(#clip0_0_12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4866 14.2022H30.7712",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.4866 23.6702H30.7712",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.46804 10.6517V5.91762C9.46804 5.60374 9.59273 5.30271 9.81468 5.08076C10.0366 4.8588 10.3377 4.73411 10.6515 4.73411H29.5877C29.9016 4.73411 30.2026 4.8588 30.4246 5.08076C30.6465 5.30271 30.7712 5.60374 30.7712 5.91762V31.9548C30.7712 32.2687 30.6465 32.5697 30.4246 32.7917C30.2026 33.0136 29.9016 33.1383 29.5877 33.1383H10.6515C10.3377 33.1383 10.0366 33.0136 9.81468 32.7917C9.59273 32.5697 9.46804 32.2687 9.46804 31.9548V27.2208",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.1196 27.2208V33.1384",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.1196 4.73411V10.6517",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.3031 10.6517H5.91752C5.26389 10.6517 4.73401 11.1816 4.73401 11.8352V26.0373C4.73401 26.6909 5.26389 27.2208 5.91752 27.2208H21.3031C21.9568 27.2208 22.4866 26.6909 22.4866 26.0373V11.8352C22.4866 11.1816 21.9568 10.6517 21.3031 10.6517Z",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.6515 15.3857L16.5691 22.4867",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.5691 15.3857L10.6515 22.4867",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8723,
    height: 37.8723,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcelLogo);
export default __webpack_public_path__ + "static/media/microsoft-excel-logo.b44900837b11610afd658173836d7668.svg";
export { ForwardRef as ReactComponent };